import React, { useEffect } from "react"
import Button from "aldoo-ra/Button"
import { refreshStoreAccount } from "../storeApi"
import { navigate } from "vike/client/router"
import useT from "../hooks/useT"
import useSearchParams from "../hooks/useSearchParams"
import { webPid } from "../utils/contentRoutes"
import { XMarkIcon } from "@heroicons/react/24/outline"

/**
 * /user/welcome[?bookPid=] — the dialog shown after a subscription was
 * created (old User/index.jsx Welcome): logo, "Welcome!", Continue to
 * Catalog; closing returns to the product or to the profile.
 */
export default function Welcome() {
  const t = useT()
  const params = useSearchParams()
  const productPid = params.get("bookPid")
  const close = () => navigate(productPid ? `/book/${webPid(productPid)}` : "/user")
  // old User/index.jsx refreshed the store account when landing on /user/welcome
  useEffect(() => {
    refreshStoreAccount().catch(() => {})
  }, [])

  return (
    <div className="fixed inset-0 z-[550] flex items-center justify-center bg-black/60 p-4" data-testid="welcome-dialog">
      <div
        role="dialog"
        aria-modal="true"
        className="relative w-full max-w-[600px] overflow-hidden rounded-[16px] bg-paper bg-cover bg-[65%_center]"
        style={{ backgroundImage: "url(/static/images/subscription-welcome-screen.png)" }}
      >
        <button type="button" onClick={close} aria-label={t`Close`} className="absolute right-3 top-3 rounded-full bg-white/70 p-1 text-text hover:bg-white">
          <XMarkIcon className="w-6 h-6" />
        </button>
        <div className="flex w-full sm:w-[300px] flex-col items-center px-4 sm:px-[30px]">
          <img src="/static/p-images/aldoo--277x58.webp" alt="Aldoo logo" width={290} height={61} className="mt-[50px] mb-[46px] w-[250px] sm:w-[290px] h-auto object-contain" />
          <h1 className="m-0 mb-10 self-start text-[42px] font-black">{t`Welcome!`}</h1>
        </div>
        <div className="flex justify-center sm:justify-start sm:pl-[35px] pb-[50px]">
          <Button variant="primary_l" className="w-[250px] sm:w-[290px] min-w-0" onClick={() => navigate("/categories")}>
            {t`Continue to Catalog`}
          </Button>
        </div>
      </div>
    </div>
  )
}
